<template>
  <div
    class="c-loading-indicator"
    :class="{ 'c-loading-indicator--visible': visible }"
  >
    <div class="c-loading-indicator__icon">
      Loading
    </div>
  </div>
</template>

<script>
export default {
  name: "c-loading-indicator",
  props: ["visible"]
};
</script>

<style lang="scss">
.c-footer + .c-loading-indicator {
  @include u-fill(toRem(80px), 0, 0, 0);
}

.c-loading-indicator {
  $root: &;
  @include u-fill(0, 0, 0, 0);
  background: rgba(255, 255, 255, 0.8);
  z-index: z("loadingIndicator");
  transition: 0.15s ease-in opacity 0.3s;
  pointer-events: none;
  opacity: 0;

  &__icon {
    position: fixed;
    top: 50%;
    left: 50%;
    opacity: 0;
    transition: 0.1s ease-in opacity 0.3s;
    color: transparent;
    transform: translate(-50%, -50%);
    width: toRem(60px);
    height: toRem(60px);

    &:after {
      content: "";
      @include u-fill(1px, 1px, 1px, 1px);
      border: 3px solid rgba($s-cp-sup-red, 0.4);
      border-top-color: $s-cp-sup-red;
      border-radius: 50%;
      animation: spin 1s ease-in-out infinite;
    }
  }

  &--visible {
    opacity: 1;
    pointer-events: all;
    transition-delay: 0s !important;
    #{$root}__icon {
      opacity: 1;
      transition-delay: 0s !important;
    }
  }
}
</style>
